// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3CnZR","inner":"Footer_inner__1z8rE","nextIcon":"Footer_nextIcon__ccRBz","innerLeft":"Footer_innerLeft__3dcAu"};